import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeletePopupComponent } from './delete-popup/delete-popup.component';
import { DeleteAcknowledgementDialogComponent } from './delete-acknowledgement-dialog/delete-acknowledgement-dialog.component';

@NgModule({
  declarations: [DeletePopupComponent, DeleteAcknowledgementDialogComponent],
  imports: [
    CommonModule
  ],
  exports: [DeletePopupComponent, DeleteAcknowledgementDialogComponent]
})
export class DeleteModule { }
